"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
var notistack_1 = require("notistack");
var react_1 = require("react");
var useToast = function () {
    var _a = (0, notistack_1.useSnackbar)(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var showToast = function (message, variant, onClose) {
        if (variant === void 0) { variant = "info"; }
        enqueueSnackbar(message, {
            variant: variant,
            persist: false,
            onClose: function () {
                if (onClose) {
                    onClose();
                }
            },
        });
    };
    var dismissToast = (0, react_1.useCallback)(function (id) {
        closeSnackbar(id);
    }, [closeSnackbar]);
    return { showToast: showToast, dismissToast: dismissToast };
};
exports.useToast = useToast;
